import { projectContext } from '@/layouts/MainLayout'
import { Menu } from 'antd'
import React, { memo, useMemo } from 'react'
import { useNavigate } from 'react-router'
import { Outlet, useMatch } from 'react-router-dom'
import styles from './index.module.less'

export default memo(function ProjectSetting() {
  const navigate = useNavigate()
  const match = useMatch('/main/projects/:projectId/setting/:key/*')
  const activeKey = useMemo(() => match?.params.key || '', [match])
  const menuItems = useMemo(() => {
    const items = [
      // { label: 'Components', key: 'components' },
      { label: 'Unit Set', key: 'unit-set' },
      // { label: 'Equipments', key: 'simulator-equipments' },
      // { label: 'Role', key: 'role' }
      { label: 'Cases', key: 'cases' },
      { label: 'Property Sets', key: 'property-sets' },
    ]
    return items
  }, [])

  return (
    <div>
      <div className={styles.container}>
        <div className={styles.sider}>
          <Menu
            items={menuItems}
            className={'setting-menu'}
            mode='inline'
            selectedKeys={[activeKey]}
            onSelect={({ key }) => {
              navigate(key)
            }}
          />
        </div>
        <div className={styles.content}>
          <Outlet />
        </div>
      </div>
    </div>
  )
})
